import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { AppContext } from '@prisjakt/ui-app-context';
import T from '@prisjakt/ui-translate';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import PersonalizationInterest from './components/personlization-interest';
import PageHeader from '../../components/page-header';
import PageContent from '../../components/page-content';
import * as S from './styles';
import actions from './actions/personalization';
import { readPersonalizationSettings } from './storage/personalization';

const Personalization = props => {
  const { data, tracking, removeInterest, addInterest } = props;
  const { t } = useContext(AppContext);

  if (
    data.recommendation.products.fallbackToDefault ||
    !tracking.behavior_tracking_improvement ||
    !tracking.personalization
  ) {
    return <Redirect to="/" />;
  }

  const categories = [
    ...data.recommendation.products.nodes,
    ...data.recommendation.newReleases.nodes,
    ...data.recommendation.preReleases.nodes,
  ]
    .map(product => product.category)
    .filter(category => category)
    .filter(
      (category, index, array) =>
        array.findIndex(x => x.id === category.id) === index
    );

  const settings = readPersonalizationSettings();

  return (
    <PageContent>
      <Breadcrumb
        homeText={t('common', 'breadcrumb.home')}
        path={[
          {
            id: '1',
            name: t('account', 'personalization.headline'),
            pathName: '',
          },
        ]}
      />
      <PageHeader title={t('account', 'personalization.headline')} />
      <S.PersonalizationDescription>
        <p>{t('account', 'personalization.description')}</p>
        <p>
          <T domain="account">personalization.privacy-settings.md</T>
        </p>
      </S.PersonalizationDescription>
      <S.PersonalizationInterests>
        <PersonalizationInterest
          categories={categories}
          settings={settings}
          removeInterest={removeInterest}
          addInterest={addInterest}
        />
      </S.PersonalizationInterests>
    </PageContent>
  );
};

Personalization.propTypes = {
  data: PropTypes.shape({
    recommendation: PropTypes.shape({
      products: PropTypes.shape({
        fallbackToDefault: PropTypes.bool,
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            logo: PropTypes.string,
          })
        ),
      }),
      newReleases: PropTypes.shape({
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            logo: PropTypes.string,
          })
        ),
      }),
      preReleases: PropTypes.shape({
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            logo: PropTypes.string,
          })
        ),
      }),
    }),
  }).isRequired,
  tracking: PropTypes.shape({
    behavior_tracking_improvement: PropTypes.bool,
    personlization: PropTypes.bool,
  }),
  removeInterest: PropTypes.func.isRequired,
  addInterest: PropTypes.func.isRequired,
};

Personalization.defaultProps = {
  tracking: {
    behavior_tracking_improvement: true,
    personlization: true,
  },
};

export default connect(
  state => ({ tracking: state.areas.user.tracking.settings }),
  actions
)(memo(Personalization));
